/* ==================================================================
   Page panier (LR Presse) — /cart
   Rend l'estimateur de frais de livraison REPLIABLE (en-tête crème cliquable),
   replié par défaut, et renomme son bouton d'action en « Calculer » (la maquette
   met « Estimer les frais de livraison » sur l'en-tête, « Calculer » sur le bouton).
   Chargé uniquement sur la page panier via sections/main-cart-footer.liquid.
   ================================================================== */
(function () {
  'use strict';

  function init() {
    var sc = document.querySelector('.template-cart .shipping-calculator');
    if (!sc || sc.dataset.lrCartInit) return;
    sc.dataset.lrCartInit = '1';

    var header = document.createElement('div');
    header.className = 'shipping-calculator-header';
    header.innerHTML =
      '<span>Estimer les frais de livraison</span><span aria-hidden="true">▾</span>';
    sc.insertBefore(header, sc.firstChild);
    sc.classList.add('is-collapsed');
    header.addEventListener('click', function () {
      sc.classList.toggle('is-collapsed');
    });

    var btn = sc.querySelector('form > button.button');
    if (btn) btn.textContent = 'Calculer';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
